import { OxygenSaturationScale } from '../types';
export const getOxygenSaturationScale = function () {
  let oxygenFlowRate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  let useScale2Air = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (oxygenFlowRate > 0) {
    return OxygenSaturationScale.Scale2Oxygen;
  }

  if (useScale2Air) {
    return OxygenSaturationScale.Scale2Air;
  }

  return OxygenSaturationScale.Scale1;
};
//# sourceMappingURL=oxygen.js.map